<script>
import { Doughnut } from 'vue-chartjs';
import { scale } from '../../utils/colors';
import DoughnutLabel from 'chartjs-plugin-doughnutlabel';

export default {
  extends: Doughnut,
  data() {
    return {
      hiddenLabels: [],
    };
  },
  watch: {
    chartData: {
      handler: function(newData, oldData) {
        if (oldData) {
          let chart = this.$data._chart;
          // Get new and old DataSet Labels
          let newDatasetLabels = newData.datasets.map(dataset => {
            return dataset.label;
          });

          let oldDatasetLabels = oldData.datasets.map(dataset => {
            return dataset.label;
          });

          // Stringify 'em for easier compare
          const oldLabels = JSON.stringify(oldDatasetLabels);
          const newLabels = JSON.stringify(newDatasetLabels);

          // Check if Labels are equal and if dataset length is equal
          if (
            newLabels === oldLabels &&
            oldData.datasets.length === newData.datasets.length
          ) {
            newData.datasets.forEach((dataset, i) => {
              // Get new and old dataset keys
              const oldDatasetKeys = Object.keys(oldData.datasets[i]);
              const newDatasetKeys = Object.keys(dataset);

              // Get keys that aren't present in the new data
              const deletionKeys = oldDatasetKeys.filter(key => {
                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
              });

              // Remove outdated key-value pairs
              deletionKeys.forEach(deletionKey => {
                delete chart.data.datasets[i][deletionKey];
              });

              // Update attributes individually to avoid re-rendering the entire chart
              for (const attribute in dataset) {
                if (dataset.hasOwnProperty(attribute)) {
                  chart.data.datasets[i][attribute] = dataset[attribute];
                }
              }
            });

            if (newData.hasOwnProperty('labels')) {
              chart.data.labels = newData.labels;
              this.$emit('labels:update');
            }
            if (newData.hasOwnProperty('xLabels')) {
              chart.data.xLabels = newData.xLabels;
              this.$emit('xlabels:update');
            }
            if (newData.hasOwnProperty('yLabels')) {
              chart.data.yLabels = newData.yLabels;
              this.$emit('ylabels:update');
            }
            chart.update();
            this.$emit('chart:update');
          } else {
            if (chart) {
              chart.destroy();
              this.$emit('chart:destroy');
            }
            this.renderChart(this.chartData, this.options);
            this.$emit('chart:render');
          }
        } else {
          if (this.$data._chart) {
            this.$data._chart.destroy();
            this.$emit('chart:destroy');
          }
          this.renderChart(this.chartData, this.options);
          this.$emit('chart:render');
        }
      },
      deep: true,
    },
    hiddenLabels: {
      handler: function(val, oldVal) {
        this.$emit('filter', val);
      },
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const getTotal = function(myDoughnutChart) {
      const {_meta} = myDoughnutChart.config.data.datasets[0];
      const {total} = _meta[Object.keys(_meta)[0]];
      return total;
    }

    const options = {
      title: {
        display: true,
        text: this.title,
      },
      legend: {
        position: 'bottom',
        onClick: (e, legendItem) => {
          if (legendItem.hidden === false) {
            this.hiddenLabels.push(legendItem.text);
          } else {
            const index = this.hiddenLabels.indexOf(legendItem.text);
            this.hiddenLabels.splice(index, 1);
          }

          var index = legendItem.index;
          var chart = this.$data._chart;
          var i, ilen, meta;

          for (
            i = 0, ilen = (chart.data.datasets || []).length;
            i < ilen;
            ++i
          ) {
            meta = chart.getDatasetMeta(i);
            // toggle visibility of index if exists
            if (meta.data[index]) {
              meta.data[index].hidden = !meta.data[index].hidden;
            }
          }

          chart.update();
        },
      },
      plugins: {
        doughnutlabel: {
          labels: [
            {
              text: getTotal,
              font: {
                size: '20'
              },
              color: 'grey'
            }
          ]
        }
      },
    };
    this.addPlugin(DoughnutLabel);
    this.renderChart(this.chartData, options);
  },
  computed: {
    chartData() {
      const chartdata = {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],

        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [],
      };

      const colors = scale(this.data.length);
      this.data.map((e, i) => {
        chartdata.labels.push(e.label);
        chartdata.datasets[0].data.push(e.value);

        chartdata.datasets[0].backgroundColor.push(colors[i]);
      });
      return chartdata;
    },
  },
};
</script>
